export const ANON_USER_ID_KEY = 'anon_user_id';
export const FIREBASE_UID_KEY = 'firebase_uid';
export const FIREBASE_EMAIL_KEY = 'firebase_email';

function generateUUID(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback RFC4122 v4
  const bytes = new Uint8Array(16);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < 16; i++) bytes[i] = Math.floor(Math.random() * 256);
  }
  // Per RFC 4122 section 4.4
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant
  const toHex = (n: number) => n.toString(16).padStart(2, '0');
  return (
    toHex(bytes[0]) + toHex(bytes[1]) + toHex(bytes[2]) + toHex(bytes[3]) + '-' +
    toHex(bytes[4]) + toHex(bytes[5]) + '-' +
    toHex(bytes[6]) + toHex(bytes[7]) + '-' +
    toHex(bytes[8]) + toHex(bytes[9]) + '-' +
    toHex(bytes[10]) + toHex(bytes[11]) + toHex(bytes[12]) + toHex(bytes[13]) + toHex(bytes[14]) + toHex(bytes[15])
  );
}

export function getOrCreateAnonUserId(): string {
  try {
    const existing = localStorage.getItem(ANON_USER_ID_KEY);
    if (existing && existing.length > 0) return existing;
    const id = generateUUID();
    localStorage.setItem(ANON_USER_ID_KEY, id);
    return id;
  } catch (_e) {
    // localStorage might be unavailable; just return an in-memory id
    return generateUUID();
  }
}

export function getAnonUserId(): string | null {
  try {
    return localStorage.getItem(ANON_USER_ID_KEY);
  } catch (_e) {
    return null;
  }
}

export function getFirebaseUid(): string | null {
  try {
    return localStorage.getItem(FIREBASE_UID_KEY);
  } catch (_e) {
    return null;
  }
}

export function setFirebaseUid(uid: string): void {
  try {
    localStorage.setItem(FIREBASE_UID_KEY, uid);
  } catch (_e) {
    // localStorage might be unavailable
  }
}

export function clearFirebaseUid(): void {
  try {
    localStorage.removeItem(FIREBASE_UID_KEY);
  } catch (_e) {
    // localStorage might be unavailable
  }
}

export function getFirebaseEmail(): string | null {
  try {
    return localStorage.getItem(FIREBASE_EMAIL_KEY);
  } catch (_e) {
    return null;
  }
}

export function setFirebaseEmail(email: string): void {
  try {
    localStorage.setItem(FIREBASE_EMAIL_KEY, email);
  } catch (_e) {
    // localStorage might be unavailable
  }
}

export function clearFirebaseEmail(): void {
  try {
    localStorage.removeItem(FIREBASE_EMAIL_KEY);
  } catch (_e) {
    // localStorage might be unavailable
  }
}

// 🚀 Get user context for API calls
export function getUserContext() {
  const guestUserId = getAnonUserId();
  const firebaseUid = getFirebaseUid();
  const userEmail = getFirebaseEmail();
  
  return {
    guest_user_id: guestUserId,
    firebase_uid: firebaseUid,
    user_email: userEmail,
  };
}

// 🚀 Create API headers with user context
export function createApiHeaders(additionalHeaders: Record<string, string> = {}) {
  const userContext = getUserContext();
  
  
  return {
    'Content-Type': 'application/json',
    'X-Guest-User-ID': userContext.guest_user_id || '',
    'X-Firebase-UID': userContext.firebase_uid || '',
    'X-User-Email': userContext.user_email || '',
    ...additionalHeaders,
  };
}


